import React from "react";
import { isValNull, getPath } from "../../../utils/index";
import styled from "styled-components";
import TimelineElement from "./TimelineElement";
import TableFields from "../../../constants/OrderPayout/LedgerTableFields.json";
import Table from "../../Common/Table/index";
import { Tooltip } from "@material-ui/core";
import { Time, InfoLine } from "sushiweb/Icons";
import Share from "sushiweb/Icons/all/Share";
import { getDashboardUrl } from "../../../views/Home";

const PayoutTimeline = (props) => {
  const { trips } = props;
  const [showLedgers, setShowLedgers] = React.useState([]);
  const [showTable, setShowTable] = React.useState(false);

  if (isValNull(trips) || trips.length === 0) {
    return <p>Trips Not Found</p>;
  }

  const getFieldValue = (item, key) => {
    if (key === "rate_card_id" || key === "rate_card_type") {
      const url = getDashboardUrl();
      return (
        <a
          href={
            url +
            `/admin/rules_dashboard/view/${item["rate_card_type"]}/${item["rate_card_id"]}`
          }
          target={"_blank"}
        >
          {item[key]}
        </a>
      );
    }
    if (key === "amount") {
      return "₹" + item[key];
    }
    return item[key];
  };

  const handleTimeLineClick = (ledgers) => {
    setShowTable(true);
    if (!ledgers) {
      setShowLedgers([]);
      return;
    }
    setShowLedgers(ledgers);
  };

  const handleMissingRateCard = (trip) => {
    let data = [];
    return (
      <MissingRateCardWrapper>
        <h3 className={"text-center"}>
          {trip.ledgers.message} {"(Trip ID #" + trip.delivery_trip_id + ")"}
        </h3>
        {Object.keys(trip.ledgers.missing_rate_card_data).map((key) => {
          data.push({
            key: key,
            value: trip.ledgers.missing_rate_card_data[key],
          });
        })}
        {data && data.length > 0 && (
          <React.Fragment>
            <p className={"text-center"}>
              Below is the helpful data to find what went wrong
            </p>{" "}
            <br />
            <Table
              fields={[
                {
                  heading: "Key",
                  key: "key",
                },
                {
                  heading: "Value",
                  key: "value",
                },
              ]}
              list={data}
              getFieldValue={getFieldValue}
            />
          </React.Fragment>
        )}
      </MissingRateCardWrapper>
    );
  };

  const getEstimatedEarningToolTipTitle = (trip) => {
    if (
      getPath(trip, "estimated_details", {}) &&
      getPath(trip, "estimated_details.earning", 0)
    ) {
      return "Estimated Earning : ₹" + trip.estimated_details.earning;
    }
    return "Estimated details not available";
  };
  const showTripEarning = (trip) => {
    if (getPath(trip, "ledgers.total_earnings", false)) {
      return (
        <React.Fragment>
          <span>
            {" "}
            Total Earning{" "}
            {trip.flow_type === "BACKWARD"
              ? "(" + trip.flow_type + ")"
              : ""}{" "}
          </span>
          :<span> ₹{trip.ledgers.total_earnings}</span>
        </React.Fragment>
      );
    }
    if (getPath(trip, "ledgers.message", false)) {
      return (
        <React.Fragment>
          <span> {trip.ledgers.message}</span>
        </React.Fragment>
      );
    }
    return <span>DP didn't earned any pay on this trip.</span>;
  };

  const openOrderRun = (shipment_ref_id) => {
    if (!shipment_ref_id) {
      return;
    }
    const url = `${getDashboardUrl()}/tracking/track?id=${shipment_ref_id}`;
    window.open(url);
  };

  const ViewOrderRun = (props) => {
    return (
      <Tooltip
        title={
          props.shipment_ref_id
            ? "Track Order run here"
            : "Order Run is not available"
        }
        arrow
        placement={"top"}
        followCursor
      >
        <OrderRunWrapper
          onClick={() => openOrderRun(props.shipment_ref_id)}
          disabled={!props.shipment_ref_id}
        >
          <span style={{ margin: "auto" }}> View Order Run</span>
          <Share
            size={14}
            color={!props.shipment_ref_id ? "#80808040" : "#50b547"}
          />
        </OrderRunWrapper>
      </Tooltip>
    );
  };

  return (
    <React.Fragment>
      <OrderPayoutTimeLineWrapper>
        {trips.map((trip, index) => {
          if (
            !trip.ledgers ||
            !trip.ledgers.trip_pay ||
            !trip.ledgers.trip_pay.ledgers
          ) {
            if (trip.ledgers.message) {
              return handleMissingRateCard(trip);
            } else {
              return (
                <p>
                  Accounting for this trip is under process or not available
                </p>
              );
            }
          }
          return (
            <React.Fragment>
              <TimeLineWrapper>
                <TimeHeader>
                  <Tooltip title={"Click to copy"} arrow placement={"top-end"}>
                    <div
                      className={"id_heading"}
                      onClick={() => {
                        navigator.clipboard.writeText(trip.delivery_trip_id);
                      }}
                    >
                      <InfoLine size={14} color={"#2781e7"} />
                      <p>
                        Trip #{trip.delivery_trip_id}{" "}
                        {trip.flow_type === "BACKWARD"
                          ? "(" + trip.flow_type + ")"
                          : ""}
                      </p>
                    </div>
                  </Tooltip>
                  <Tooltip>
                    <div>
                      <ViewOrderRun shipment_ref_id={trip.shipment_ref_id} />
                    </div>
                  </Tooltip>
                  {getPath(trip, "ledgers.payout_computed_at", false) && (
                    <Tooltip
                      title={"Payout Computation Time"}
                      arrow
                      placement={"top-end"}
                    >
                      <div className={"accounting_time"}>
                        {/*<Time size={14}/>*/}
                        <p>
                          {new Date(
                            trip.ledgers.payout_computed_at
                          ).toLocaleString("en-US", {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            second: "numeric",
                            hour12: true,
                          })}
                        </p>
                      </div>
                    </Tooltip>
                  )}
                </TimeHeader>
                <Tooltip
                  title={getEstimatedEarningToolTipTitle(trip)}
                  arrow
                  placement={"top"}
                >
                  <Heading>{showTripEarning(trip)}</Heading>
                </Tooltip>

                <TimeLineElementsWrapper>
                  <TimelineElement
                    amount={0}
                    reportType={"Order Ack"}
                    distance={""}
                    hideLine={true}
                    handleClick={() => {
                      handleTimeLineClick([]);
                    }}
                  />
                  {getPath(trip, "ledgers.trip_pay.ledgers", []).map(
                    (ledger, index) => (
                      <TimelineElement
                        amount={ledger.amount}
                        reportType={ledger.report_type}
                        waitTime={ledger.wait_time}
                        distance={ledger.accounting_distance + " km"}
                        actualDistance={
                          ledger.actual_distance
                            ? ledger.actual_distance + " km"
                            : ""
                        }
                        handleClick={() => {
                          handleTimeLineClick(ledger.ledgers);
                        }}
                      />
                    )
                  )}
                  {getPath(trip, "ledgers.surge_pay.amount", 0) > 0 && (
                    <TimelineElement
                      amount={trip.ledgers.surge_pay.amount}
                      reportType={"Surge Pay"}
                      distance={""}
                      handleClick={() => {
                        handleTimeLineClick(trip.ledgers.surge_pay.ledgers);
                      }}
                    />
                  )}
                  {getPath(trip, "ledgers.ldrp_pay.amount", 0) > 0 && (
                    <TimelineElement
                      amount={trip.ledgers.ldrp_pay.amount}
                      reportType={"LDRP"}
                      distance={""}
                      handleClick={() => {
                        handleTimeLineClick(trip.ledgers.ldrp_pay.ledgers);
                      }}
                    />
                  )}
                  {getPath(trip, "ledgers.tip_pay.amount", 0) > 0 && (
                    <TimelineElement
                      amount={trip.ledgers.tip_pay.amount}
                      reportType={"Tip Pay"}
                      distance={""}
                      handleClick={() => {
                        handleTimeLineClick(trip.ledgers.tip_pay.ledgers);
                      }}
                    />
                  )}
                  {getPath(trip, "ledgers.trip_pickup_pay.amount", 0) > 0 && (
                    <TimelineElement
                      amount={trip.ledgers.trip_pickup_pay.amount}
                      reportType={"Trip Pickup Pay"}
                      distance={""}
                      handleClick={() => {
                        handleTimeLineClick(trip.ledgers.trip_pickup_pay.ledgers);
                      }}
                    />
                  )}
                  {getPath(trip, "ledgers.other_pay.amount", 0) > 0 && (
                    <TimelineElement
                      amount={trip.ledgers.other_pay.amount}
                      reportType={"Other Pay"}
                      distance={""}
                      handleClick={() => {
                        handleTimeLineClick(trip.ledgers.other_pay.ledgers);
                      }}
                    />
                  )}
                </TimeLineElementsWrapper>
              </TimeLineWrapper>
            </React.Fragment>
          );
        })}
      </OrderPayoutTimeLineWrapper>
      {showTable && showLedgers.length ? (
        <Table
          fields={TableFields}
          list={showLedgers}
          getFieldValue={getFieldValue}
        />
      ) : showTable ? (
        <p>No Accounting data available for this event.</p>
      ) : null}
    </React.Fragment>
  );
};

const OrderRunWrapper = styled.div`
  padding: 5px;
  display: flex;
  justify-content: space-between;
  width: 150px;
  border: 1px solid ${(props) => (props.disabled ? "#80808040" : "#50b547")};
  border-radius: 5px;
  span {
    text-decoration: none;
    color: ${(props) => (props.disabled ? "#80808040" : "#50b547")} !important;
    font-size: 15px;
  }
  &:hover {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
`;

const OrderPayoutTimeLineWrapper = styled.section`
  display: flex;
  align-items: center;
  overflow: auto;
  position: relative;
  color: #828282;

  .id_heading {
    text-align: right;
    font-weight: bold;
    font-size: 14px !important;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    padding: 0.5rem 1.1rem;
    margin: 10px;
    background: #fff;
    box-shadow: 0 4px 8px rgb(0 0 0 / 10%);
    border-radius: 0.5rem;
    color: #2781e7;
    cursor: pointer;

    p {
      padding: 5px;
    }
  }

  .accounting_time {
    text-align: right;
    font-weight: bold;
    font-size: 14px !important;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    padding: 0.5rem 1.1rem;
    margin: 10px;
    cursor: pointer;

    p {
      border-bottom: 0.5px dashed #828282;
    }
  }
`;

const MissingRateCardWrapper = styled.div`
  display: unset;
  justify-content: unset;
  align-items: center;
  width: 100%;
`;

const TimeLineWrapper = styled.section`
  height: 20rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-width: 60%;
  background-color: #f6f9fd;
  margin: 10px;
  border-radius: 10px;
  border: 1px solid #e8e8e8;
`;

const TimeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const Heading = styled.h1`
  font-size: 18px;
`;
const TimeLineElementsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default PayoutTimeline;
